import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./movingDetails.scss";
import { getFullName } from "../../utils/common";
import { Col, Row } from "react-bootstrap";
import { CallIcon, LocationIcon } from "../../components/Icons";

const SavedAddress = (props) => {
  const [selectedAddress, setSelectedAddress] = useState(null);

  const getPlaceDetailsFromCoordinates = (latitude, longitude, callback) => {
    const geocoder = new window.google.maps.Geocoder();

    const latLng = new window.google.maps.LatLng(latitude, longitude);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          // results[0] contains the most detailed result
          callback(results[0]);
        } else {
          console.error("No results found");
        }
      } else {
        console.error(`Geocoder failed due to: ${status}`);
      }
    });
  };

  const handleAddressSelection = (address) => {
    if (props.type === "sender") {
      props.setSenderDetails(address);
      getPlaceDetailsFromCoordinates(
        address?.loc?.coordinates[0],
        address?.loc?.coordinates[1],
        (placeDetails) => {
          props.setStartPlace(placeDetails);
        }
      );
    } else if (props.type === "receiver") {
      props.setReceiverDetails(address);
      getPlaceDetailsFromCoordinates(
        address?.loc?.coordinates[0],
        address?.loc?.coordinates[1],
        (placeDetails) => {
          props.setEndPlace(placeDetails);
        }
      );
    }
    props.handleCloseAddress();
  };

  return (
    <>
      <Modal
        show={props.savedAddressModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="z-3 position-relative"
          onClick={() => props.setSavedAddressModal(false)}
          closeButton
        >
          <Modal.Title>Saved address</Modal.Title>
        </Modal.Header>
        <Modal.Body className="z-1 position-relative">
          <Row className="g-3">
            {props.savedAddressList?.map((address) => (
              <Col md={6} key={address.id}>
                <div className="box-wrapper save-address-details  h-100">
                  <div className="save-address-info">
                    <div className="save-address-name">{`${getFullName(
                      address.firstName,
                      address.lastName
                    )}`}</div>
                    <div className="save-address-phone">
                      <div>
                        <CallIcon />
                      </div>
                      <div>{address.phone}</div>
                    </div>
                    <div className="save-address">
                      <div>
                        <LocationIcon />
                      </div>
                      <div>{address.address}</div>
                    </div>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="savedAddress"
                      value={address.id}
                      checked={selectedAddress === address.id}
                      onChange={() => handleAddressSelection(address)}
                    />
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SavedAddress;
